const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/eCheckin/sections/PatientInfo.tsx';
import { forwardRef, useMemo } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { Link, LinksBlock } from 'App/components/eCheckin/components/fields/LinksBlock';
import { useTheme } from '@mui/material/styles';
import { css, cx } from '@emotion/css';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { Divider } from '@mui/material';

const links: Link[] = [
    {
        name: 'statAufenthalt',
        text: textMap.statAufenthalt,
        href: 'https://www.zgks.ch/patienten-besucher/spitalaufenthalt/stationaerer-aufenthalt',
    },
    {
        name: 'ambAufenthalt',
        text: textMap.ambAufenthalt,
        href: 'https://www.zgks.ch/patienten-besucher/spitalaufenthalt/ambulanter-aufenthalt',
    },
];

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            primaryTextStyle: css`
                color: ${theme.palette.primary.main};
            `,
            firstLine: css`
                color: ${theme.palette.primary.main};
                font-weight: bold;
            `,
            contactWrapper: css`
                line-height: 24px;
            `,
        }),
        [theme]
    );
}

export const PatientInfo = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const classes = useCSSClasses();
    const { formatMessage } = useIntl();

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <div className={cx(classes.primaryTextStyle, classes.firstLine)}>
                {formatMessage(textMap.informationHeader)}
            </div>
            <div>{formatMessage(textMap.questionForMoreInformation)}</div>
            <div className={classes.primaryTextStyle}>{formatMessage(textMap.administrativeQuestion)}</div>
            <div className={classes.contactWrapper}>
                <div>{formatMessage(textMap.openingTimeWorkWeek)}</div>
                <div>{formatMessage(textMap.openingTimeWeekend)}</div>
                <div>T: +41 41 399 44 46</div>
                <div>
                    E: <a href="mailto:pataufnahme@zgks.ch">pataufnahme@zgks.ch</a>
                </div>
            </div>
            <Divider />
            <LinksBlock links={links} basePath={path} required={true} label={textMap.PatInfoConfirmation} />
        </ECheckinSection>
    );
});

PatientInfo.displayName = 'PatientInfo';

export default PatientInfo;
